/* Product gallery, item 159 (9 Sept).

   Bianca, on the draft: "when you scroll down the page it's like a lot of
   blank space on the right hand side. It just looks like an unfinished page.
   I think you probably need to just be able to sit there and actually just
   choose between image one two three."

   The section renders every slide stacked and the thumbnail rail hidden, so a
   page with no JavaScript is exactly the page that shipped before this. Only
   once this file runs does data-wn-gallery-ready appear, and only then does
   the CSS collapse the stack to one slide and reveal the rail. That ordering
   is deliberate: a photograph must never be unreachable because a script
   failed to load.

   A single-media product gets no rail and no ready flag, so the one slide
   simply stays where it is. */
(function () {
  var root = document.querySelector('[data-wn-pdp-gallery]');
  if (!root) return;

  var slides = [].slice.call(root.querySelectorAll('[data-wn-slide]'));
  var thumbs = [].slice.call(root.querySelectorAll('[data-wn-thumb]'));
  if (slides.length < 2 || thumbs.length < 2) return;

  root.setAttribute('data-wn-gallery-ready', '');

  /* Every slide but the first is loading="lazy", and a lazy image inside a
     display:none slide has never entered the viewport, so it has no bytes at
     all. Revealing it would leave the customer looking at an empty square
     while it fetches. Promoting the attribute to eager starts the load
     immediately, hidden or not, so the neighbours on either side of whatever
     is on the stage are always already there. It stays lazy for anything
     further away, which is the whole reason the page is not fetching fourteen
     photographs at 1400px on load. */
  function warm(i) {
    [i - 1, i, i + 1].forEach(function (n) {
      var slide = slides[n];
      if (!slide) return;
      var img = slide.querySelector('img[loading="lazy"]');
      if (img) img.setAttribute('loading', 'eager');
    });
  }

  function show(i) {
    var n = parseInt(i, 10);
    var key = String(n);
    warm(n);
    slides.forEach(function (s) {
      s.classList.toggle('is-active', s.getAttribute('data-wn-slide') === key);
    });
    thumbs.forEach(function (t) {
      var on = t.getAttribute('data-wn-thumb') === key;
      t.classList.toggle('is-active', on);
      t.setAttribute('aria-selected', on ? 'true' : 'false');
    });
    // A video left on the stage keeps streaming behind a display:none slide in
    // some browsers, so stop anything that is no longer the active slide.
    [].forEach.call(root.querySelectorAll('video'), function (v) {
      var slide = v.closest ? v.closest('[data-wn-slide]') : null;
      if (slide && !slide.classList.contains('is-active')) {
        try { v.pause(); } catch (e) {}
      }
    });
  }

  thumbs.forEach(function (t) {
    t.addEventListener('click', function () {
      show(t.getAttribute('data-wn-thumb'));
    });
  });

  // Left and right walk the rail, which is what a tablist is expected to do.
  root.addEventListener('keydown', function (e) {
    if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
    var at = thumbs.indexOf(document.activeElement);
    if (at < 0) return;
    e.preventDefault();
    var next = e.key === 'ArrowRight'
      ? (at + 1) % thumbs.length
      : (at - 1 + thumbs.length) % thumbs.length;
    thumbs[next].focus();
    show(thumbs[next].getAttribute('data-wn-thumb'));
  });

  // Second photograph ready before anybody reaches for it.
  warm(0);
})();
